import type { BlokProps } from "@trydig/storyblok";
import { clsx } from "@trydig/ui";
import { BlokWrap } from "@/components/bloks/BlokWrap";
import { renderRichText } from "@/components/bloks/utils";
import { Asset } from "@/components/ui/Asset";
import { Container } from "@/components/ui/Container";
import { Prose } from "@/components/ui/Prose";
import { Typography } from "@/components/ui/Typography";
import type { ProductCollectionStoryblok } from "@/generated/sb/sb-types";
import { checkBlokBackground, isDarkMode } from "@/lib/utils/isDarkMode";

export const ProductCollectionBlok = ({ blok }: BlokProps<ProductCollectionStoryblok>) => {
	const bg = checkBlokBackground(blok);
	const darkMode = isDarkMode(bg);

	return (
		<BlokWrap editable={blok} asChild>
			<Container className="py-grid-section-vertical-lg">
				<div
					className=" grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-4"
					style={{ backgroundColor: bg ? bg : undefined }}
				>
					<div className="relative aspect-3/4 order-2 md:order-1">
						{blok.asset && <Asset asset={blok.asset} sizes="(min-width: 1024px) 50vw, 100vw" />}
					</div>
					<div
						className={clsx(
							"flex flex-col justify-between md:p-6 gap-8 md:gap-0 order-1 md:order-2",
						)}
					>
						<div className={clsx("flex flex-col gap-4", darkMode && "text-text-light-text-1")}>
							<Typography variant="heading-display-md">{blok.header}</Typography>
							<Typography variant="body-sm-reg">{blok.caption}</Typography>
						</div>
						<div>
							{blok.description && (
								<Prose className={clsx(darkMode && "text-text-light-text-1")}>
									{renderRichText(blok.description)}
								</Prose>
							)}
						</div>
					</div>
				</div>
			</Container>
		</BlokWrap>
	);
};
